module.exports = __webpack_public_path__ + "static/s-views-78734c9ce00a6e8341c2faef1799d6b8.svg";